const messageTitleMetaDefault = 'OKBOY - Somos tu aliado administrando tu hogar';
const messageDescriptionDefault = 'Pide los servicios de tu hogar como el gas, lavandería, limpieza y muchos más. Administra tus gastos y revisa tu historial en una sola App.';
const keywordsDefault = 'pedir gas, gas, gas lp, lavandería, planchaduria, mantenimiento, hogar, limpieza, servicios, internet, luz, recargas, plomero, gastos, pagar recibos';

export {
  messageTitleMetaDefault,
  messageDescriptionDefault,
  keywordsDefault,
};
